import request from '@/utils/request'
const api = {
  // 获取最新app版本
  getAppVersion: function () {
    return request({
      url: 'common/getAppVersion',
      method: 'get'
    })
  },
  //发送短信
  sendCode: function (data) {
    return request({
      url: 'common/sendMsg',
      method: 'post',
      data
    })
  },  //发送短信
  sendEmailCode: function (data) {
    return request({
      url: 'common/SendEmail',
      method: 'post',
      data
    })
  },
  //用户注册
  register: function (data) {
    return request({
      url: 'account/register',
      method: 'post',
      data
    })
  },
  //登陆接口
  login: function (data) {
    return request({
      url: 'account/signIn',
      method: 'post',
      data
    })
  },
  //获取用户的概括(总交易量，总天数等)
  getUserGeneral: function () {
    return request({
      url: 'userinfo/getUserGeneral',
      method: 'get'
    })
  },
  //修改密码
  changePassword: function (data) {
    return request({
      url: 'account/changePassword',
      method: 'post',
      data
    })
  },
  //找回密码
  forgetPassword: function (data) {
    return request({
      url: 'account/forgetPassword',
      method: 'post',
      data
    })
  },
  //修改头像
  changeHeaderImg: function (data) {
    return request({
      url: 'userinfo/headerImg',
      method: 'post',
      data
    })
  },
  //获取银行类型
  getBanks: function () {
    return request({
      url: 'common/getBanks',
      method: 'get'
    })
  },

  //获取用户的银行卡
  getUserBanks: function () {
    return request({
      url: 'userinfo',
      method: 'get'
    })
  },
  //获取用户的一张银行卡
  getUserByBankId: function (id) {
    return request({
      url: `userinfo/${id}`,
      method: 'get'
    })
  },
  //添加银行卡
  addBank: function (data) {
    return request({
      url: `userinfo`,
      method: 'post',
      data
    })
  },
  //修改银行卡
  changeBankInfo: function (bankId, data) {
    return request({
      url: `userinfo/${bankId}`,
      method: 'PUT',
      data
    })
  },
  //删除银行卡
  deleteBank: function (bankId) {
    return request({
      url: `userinfo/${bankId}`,
      method: 'delete'
    })
  },
  //获取bannen接口
  getBanners: function () {
    return request({
      url: 'common/getBanners',
      method: 'get'
    })
  },
  //通过id获取banner接口
  getBannerById: function (id) {
    return request({
      url: 'common/getBannerById?id=' + id,
      method: 'get',
    })
  },
  //获取订单接口
  getOrders: function (data) {
    return request({
      url: 'order/getOrders',
      method: 'post',
      data
    })
  },
  //获取异议订单条数接口
  getErrorOrders: function (t) {
    return request({
      url: 'order/getErrorOrders/?t=' + t,
      method: 'get'
    })
  },

  //获取订单详情接口
  getOrderDetail: function (param) {
    return request({
      url: 'order/getOrderDetail?orderid=' + param,
      method: 'get'
    })
  },
  //确认收到款接口
  confirmOrder: function (data) {
    return request({
      url: 'order/confirm',
      method: 'post',
      data
    })
  },
  //确认收到款接口  退返中/异议单
  returnToconfirmOrder: function (data) {
    return request({
      url: 'order/returnToconfirm ',
      method: 'post',
      data
    })
  },
  //确认收到款接口  已关闭订单
  closeToconfirmOrder: function (data) {
    return request({
      url: 'order/closeToConfirm ',
      method: 'post',
      data
    })
  },
  //没有收到款接口
  disputeOrder: function (data) {
    return request({
      url: 'order/dispute',
      method: 'post',
      data
    })
  },
  //获取承兑商可以购买的订单
  getBuyOrders: function (data) {
    return request({
      url: 'order/buyOrder',
      method: 'post',
      data
    })
  },
  //承兑商购买USDT
  buy: function (data) {
    return request({
      url: 'order/buy',
      method: 'post',
      data
    })
  },
  //获取承兑商自己购买的USDT列表
  getMyBuyOrder: function (data) {
    return request({
      url: 'order/getMyBuyOrder',
      method: 'post',
      data
    })
  },
  //承兑商确认打款
  confirmPayOrder: function (data) {
    return request({
      url: 'order/confirmPay',
      method: 'post',
      data
    })
  },
  //未收款银行凭证
  updloadAction: function (data) {
    return request({
      url: 'order/uploadPic',
      method: 'post',
      data
    })
  },
  //承兑商取消购买
  cancelPayOrder: function (data) {
    return request({
      url: 'order/cancelBuy',
      method: 'post',
      data
    })
  },
  //承兑商获取钱包信息
  getWallet: function () {
    return request({
      url: 'wallet',
      method: 'get'
    })
  },
  //承兑商提币申请
  coinUp: function (data) {
    return request({
      url: 'wallet',
      method: 'post',
      data
    })
  },
  //承兑商币流水详情
  getCoinUpList: function (data) {
    return request({
      url: 'wallet/list',
      method: 'post',
      data
    })
  },
  //承兑商币订单详情
  getCoinUpDetail: function (params) {
    return request({
      url: `wallet/detail`,
      method: 'get',
      params
    })
  },
  //承兑商获取订单评论
  getComment: function (id) {
    return request({
      url: `comment/${id}`,
      method: 'get'
    })
  },
  //承兑商提交评论
  postComment: function (data) {
    return request({
      url: `comment`,
      method: 'post',
      data
    })
  },
  //承兑商获取订单评论
  getComment: function (id) {
    return request({
      url: `comment/${id}`,
      method: 'get'
    })
  },
  //承兑商获取当前火币的买价和卖价
  // GetSymbol: function () {
  //   return request({
  //     url: 'common/GetSymbol',
  //     method: 'get'
  //   })
  // },    
  GetSymbol: function () {
    return request({
      url: 'wallet/refushUsdtWallet',
      method: 'get'
    })
  },
  //承兑商获取当前火币的买价和卖价
  Recharge: function () {
    return request({
      url: 'wallet/recharge',
      method: 'get'
    })
  },
  //承兑商获取当前火币的买价和卖价,并计算出可以提多少个币
  GetRealCoin: function (param) {
    return request({
      url: 'wallet/GetRealCoin?number=' + param,
      method: 'get'
    })
  },
  //承兑商刷新火币价格,并获取最新的最大可卖数量
  GetCoinUpPrice: function () {
    return request({
      url: 'wallet/getCoinUpPrice',
      method: 'get'
    })
  },
  //接单开关状态
  changeOrderSwitch: function (param) {
    return request({
      url: 'userinfo/updateStopTradeStatus?status=' + param,
      method: 'get'
    })
  },
  //刷新个人信息接口
  refreshUserInfo: function () {
    return request({
      url: 'userinfo/refreshUserInfo',
      method: 'get'
    })
  },
  //刷新钱包接口
  refreshWallet: function () {
    return request({
      url: 'wallet/refreshUsdtWallet',
      method: 'get'
    })
  },
  //新增支付宝账户
  addAlipay: function (data) {
    return request({
      url: `userinfo/AddAlipayBank`,
      method: 'post',
      data
    })
  },
  //新增支付宝账户(固定额度)
  addFixedAlipay: function (data) {
    return request({
      url: `userinfo/AddAlipayBankForFixAmount`,
      method: 'post',
      data
    })
  },
  editFixedAlipay: function (data) {
    return request({
      url: `userinfo/editAlipayBankForFixAmount`,
      method: 'post',
      data
    })
  },
  validFixedQrCodeCount: function (userId, bankId) {
    return request({
      url: `userbank/validFixedQrCodeCount?userId=${userId}&bankId=${bankId}`,
      method: 'get',
    });
  },
  //支付宝二维码上传
  alipayImgUpload: function (data) {
    return request({
      url: `common/upload`,
      method: 'post',
      data
    })
  },
  //支付宝二维码上传
  alipayImgListUpload: function (data) {
    return request({
      url: `common/upload2`,
      method: 'post',
      data
    })
  },
  //新增支付宝账户
  editAlipay: function (data) {
    return request({
      url: `userinfo/UpdateAlipayBank`,
      method: 'post',
      data
    })
  },
  //获取用户收款方式分组
  getUserBankGroups: function () {
    return request({
      url: 'userBank/getBanksGroup',
      method: 'get'
    })
  },
  //获取固定额度值列表
  getFixedSetting: function () {
    return request({
      url: 'userBank/fixedSetting',
      method: 'get'
    })
  },
  updateBankGroupIsUse: function (id, isUse) {
    return request({
      url: 'userBank/updateBankGroupIsUse',
      method: 'post',
      data: { 'Id': id, 'IsUse': isUse }
    })
  },
  //新增/编辑收款方式分组
  updateUserBankGroup: function (data) {
    return request({
      url: `userbank/updateUserBankGroup`,
      method: 'post',
      data
    })
  },
  getUserBankGroupById: function (id) {
    return request({
      url: 'userbank/userBankGroupDetail?id=' + id,
      method: 'get',
    })
  },
  //删除收款方式分组
  deleteUserBankGroup: function (id) {
    return request({
      url: `userbank/deleteUserBankGroup?id=` + id,
      method: 'delete'
    })
  },
  updateSingleAlipayAccount: function (data) {
    return request({
      url: `userbank/UpdateSingleAlipayAccount`,
      method: 'post',
      data
    })
  }
}
export default api